/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_SubscriptionInputs */

const en_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Subscription`)
};

const ar_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة الاشتراك`)
};

const de_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement verwalten`)
};

const es_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar suscripción`)
};

const fr_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l'abonnement`)
};

const it_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci abbonamento`)
};

const ja_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション管理`)
};

const ko_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 관리`)
};

const pt_br_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar assinatura`)
};

const ru_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление подпиской`)
};

const th_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการการสมัครสมาชิก`)
};

const tr_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliği Yönet`)
};

const zh_cn_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员管理`)
};

const zh_tw_manage_subscription = /** @type {(inputs: Manage_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱管理`)
};

/**
* | output |
* | --- |
* | "Manage Subscription" |
*
* @param {Manage_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const manage_subscription = /** @type {((inputs?: Manage_SubscriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_SubscriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_subscription(inputs)
	if (locale === "ar") return ar_manage_subscription(inputs)
	if (locale === "de") return de_manage_subscription(inputs)
	if (locale === "es") return es_manage_subscription(inputs)
	if (locale === "fr") return fr_manage_subscription(inputs)
	if (locale === "it") return it_manage_subscription(inputs)
	if (locale === "ja") return ja_manage_subscription(inputs)
	if (locale === "ko") return ko_manage_subscription(inputs)
	if (locale === "pt_br") return pt_br_manage_subscription(inputs)
	if (locale === "ru") return ru_manage_subscription(inputs)
	if (locale === "th") return th_manage_subscription(inputs)
	if (locale === "tr") return tr_manage_subscription(inputs)
	if (locale === "zh_cn") return zh_cn_manage_subscription(inputs)
	return zh_tw_manage_subscription(inputs)
});